import React from 'react';

export default function MockDataWarning() {
    return (
        <div className="local-credentials-div">
            <span>
                This environment is currently using a local credentials file for
                authentication with the service.
            </span>
        </div>
    );
}
